var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.37484 1.33337C2.60296 1.33337 1.1665 2.76983 1.1665 4.54171C1.1665 7.75004 4.95817 10.6667 6.99984 11.3451C9.0415 10.6667 12.8332 7.75004 12.8332 4.54171C12.8332 2.76983 11.3967 1.33337 9.62484 1.33337C8.53984 1.33337 7.58025 1.87208 6.99984 2.69662C6.70399 2.27523 6.31097 1.93132 5.85403 1.69402C5.3971 1.45672 4.88972 1.33301 4.37484 1.33337Z",
    fill: "current",
    stroke: "current",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.22e5f94c4cd900b3f1d1d354ae72da76.svg";
export { ForwardRef as ReactComponent };